import { render } from "./CertificateGenerator.vue?vue&type=template&id=730b077a&scoped=true"
import script from "./CertificateGenerator.vue?vue&type=script&lang=js"
export * from "./CertificateGenerator.vue?vue&type=script&lang=js"

import "./CertificateGenerator.vue?vue&type=style&index=0&id=730b077a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730b077a"]])

export default __exports__